import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import { Indicator } from './Indicator';
import { indicators } from '../../../utils/constants/misc';
import { IndicatorV2 } from './IndicatorV2';

const IndicatorWrapper = ({ colSpan, bigVersion }) => {
  return bigVersion ? (
    <Row
      gutter={[0, 24]}
      style={{ marginLeft: 18, marginRight: 18, overflow: 'auto' }}
    >
      {indicators.map((i) => (
        <Col
          xs={24}
          sm={{ span: colSpan * 2 }}
          xxl={{ span: colSpan }}
          key={i}
          className="indicator-large-col"
        >
          <IndicatorV2 purpose={i} />
        </Col>
      ))}
    </Row>
  ) : (
    <Row gutter={[16, 24]} style={{ marginRight: 16, overflow: 'auto' }}>
      {indicators.map((i) => (
        <Col xs={24} sm={24} md={12} lg={colSpan} xl={colSpan} key={i}>
          <Indicator purpose={i} />
        </Col>
      ))}
    </Row>
  );
};

IndicatorWrapper.propTypes = {
  colSpan: PropTypes.number,
  bigVersion: PropTypes.bool
};

IndicatorWrapper.defaultProps = {
  colSpan: 12,
  bigVersion: false
};

export { IndicatorWrapper };
